import axios, { AxiosRequestConfig } from 'axios';
import MockAdapter from 'axios-mock-adapter';

const ApiEnvironment = (): string =>
  process.env.GATSBY_REACT_APP_API_ENVIRONMENT;

const instance = axios.create();

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error))
      return Promise.reject({
        errorMessage: 'The request was cancelled',
      });

    return Promise.reject({
      status: error.response.status,
      data: error.response.data || {},
    });
  }
);

const httpClient = {
  delete: (url: string, config?: AxiosRequestConfig) =>
    instance.delete(url, includeAuthConfig(config)),

  get: (url: string, config?: AxiosRequestConfig) =>
    instance.get(url, includeAuthConfig(config)),

  patch: (url: string, config?: AxiosRequestConfig, data: any = {}) =>
    instance.patch(url, data, includeAuthConfig(config)),

  post: (url: string, config?: AxiosRequestConfig, data: any = {}) =>
    instance.post(url, data, includeAuthConfig(config)),

  put: (url: string, config?: AxiosRequestConfig, data: any = {}) =>
    instance.put(url, data, includeAuthConfig(config)),
};

export const mock = (delay = 0) =>
  new MockAdapter(instance, { delayResponse: delay });

export default httpClient;

function includeAuthConfig(config: AxiosRequestConfig): AxiosRequestConfig {
  const isAwsEnvironment = ApiEnvironment()?.includes('aws');
  if (isAwsEnvironment) {
    return getAwsEnvironmentConfig(config);
  }

  const isMockEnvironment = ApiEnvironment()?.includes('mock');
  if (isMockEnvironment) {
    return getMockEnvironmentConfig(config);
  }

  return config;
}

function getMockEnvironmentConfig(
  config: AxiosRequestConfig
): AxiosRequestConfig {
  const authToken = localStorage.getItem('mock_env.token');

  if (!authToken) return config;

  const authHeaders = { authorization: authToken };

  if (config == null) return { headers: authHeaders };

  return { ...config, headers: { ...config.headers, ...authHeaders } };
}

function getAwsEnvironmentConfig(
  config: AxiosRequestConfig
): AxiosRequestConfig {
  const headers = {
    ...config?.headers,
    'x-dnbapi-trace-id': uuidv4(),
  };

  return { ...config, withCredentials: true, headers };
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (placeholder) {
      const random = (Math.random() * 16) | 0;
      const value = placeholder === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    }
  );
}
